export * from './IconFishboneFilled';
